export const INITIAL_STATE = {
  isLoading: false,
  error: null,
  communityPagesLoading: false,
  data: {
    clientPages: null,
    allPages: null,
    pageDetail: null,
    pageCreated: null,
    communityPagesByType: null,
  },
};
